import { render, staticRenderFns } from "./ExamPreview.vue?vue&type=template&id=8f1914b4"
import script from "./ExamPreview.vue?vue&type=script&lang=js"
export * from "./ExamPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports